// 日订单量级配置
export const ORDER_LEVEL_OPTIONS = [
  { value: '0-50', label: '0-50' },
  { value: '50-100', label: '50-100' },
  { value: '100-1000', label: '100-1000' },
  { value: '1000-100000', label: '1000-100000' },
] as const
